import { ChangeDetectorRef, Component, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CustomValidators } from 'ng2-validation';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { CareerService } from 'src/app/services/career.service';
import { OpponentsService } from 'src/app/services/opponents.service';
import { TournamentsService } from 'src/app/services/tournamnet.service';
import { LazyLoadEvent } from "primeng/api";
import * as CryptoJS from "crypto-js";

const frontEnd = environment.frontEnd;
import {
  SwiperComponent,
  SwiperDirective,
  SwiperConfigInterface,
  SwiperScrollbarInterface,
  SwiperPaginationInterface
} from 'ngx-swiper-wrapper';
import { CommonService } from 'src/app/services/common.service';
import { ProfileService } from 'src/app/services/profile.service';
import * as moment from 'moment';
import { UserWalletService } from 'src/app/services/userWallet.service';
import { KycService } from 'src/app/services/kyc.service';
@Component({
  selector: 'app-information',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  providers: [ConfirmationService, MessageService, KycService]
})
export class InformationComponent implements OnInit {
     position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'center';
       public downloadModal: boolean = false;
  public approvedKyc: boolean;
  public submittedKyc: boolean;
  public item;
  public fullName;
  public loggedInAcademy;
  public profileDetails;
  public loggedInUser;
  public userId;
  public shareurl;
  public isLoggedIn: boolean = false;
  public data: any;
  public careerDetails;
  public skillinfoDetails;
  public skillOpponents;
  public highestSkillJumpDetails;
  public winlossDetails: any
  public winloss: any
  tournamentParticapation;
  rankingData: any;
  highestSkillJumpList: any;
  playerRating: any;
  playerRatingForHighestSkillJump: any;
  oldplayerLastRating: any;
  lessplayerRating: any;
  graterplayerRating: any;
  opponentRating: any;
  player1Value;
  player2Value;
  plusminus: any;
  highestSkillJump: any;
  playerSkills: any
  userData: any = [] = [];
  private key = CryptoJS.enc.Utf8.parse(environment.EncryptKey);
  private iv = CryptoJS.enc.Utf8.parse(environment.EncryptIV);
  public options = {
    title: {
      display: true,
      text: 'My Title',
      fontSize: 16
    },
    legend: {
      position: 'bottom'
    }
  }
  public Top_config: SwiperConfigInterface = {
    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    slidesPerView: 'auto',
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: false,
    pagination: false,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30
      }
    }
  };
  public Opponents: SwiperConfigInterface = {
    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    slidesPerView: 'auto',
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: false,
    pagination: false,
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30
      }
    }
  };
  matchTypes = environment.matchTypes;
  public opponentList: any = [];
  public opponentListCurrentYear: any;
  public tournamentList: any = [];
  public selectedYear;
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  rankData: any;
  skillsData: any;
  basicOptions: any;
  basicRankOptions: any;
  kycData: any;
  loading: boolean;
  presentKycData: boolean;
  totalRecords: any;
  public referralcode;
  yearOptions: any[] = [];
  yearRangeForChart = environment.yearRangeForChart;
  isProfileComplete: any;
  rejectKycReasonView: boolean;
  viewReason: any;
  tooltipContent: string;
  presentButrejected: boolean = false;
  walletlist: any;
  cashSpend: any;
  userBadge: string;
  amountToSpend: any;
  badgeAmout: number;
  cashSpendPercent: number;
  bankDetails: any;
  isCompleteBankVerified: boolean = false;
  kycDetails: any;
  kycVerificationComplete: boolean = false;
  isProfileCompleted: any;
  constructor(
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private userService: UserService,
    private careerService: CareerService,
    private opponentsService: OpponentsService,
    private tournamentsService: TournamentsService,
    private commonService: CommonService,
    private profileService: ProfileService,
    private walletService: UserWalletService,
    private kycService: KycService,
    private changeDetectorRef: ChangeDetectorRef,
      private renderer: Renderer2

  ) {
  }
  ngOnInit(): void {
      this.renderer.addClass(document.body, 'profilePage');
    //this.loggedInAcademy = this.tokenStorage.getUser(); 
    for (let i = 0; i < this.yearRangeForChart; i++) {
      let year = Number(2000) + i;
      this.yearOptions.push({ year: year.toString() });
    }
    let date = new Date();
    this.selectedYear = { year: date.getFullYear().toString() };
    this.basicRankOptions = {
      plugins: {
        legend: {
          labels: {
            color: '#495057'
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          }
        },
        y: {
          ticks: {
            color: '#495057',
            beginAtZero: true,
            stepSize: 10
          },
          grid: {
            color: '#ebedef'
          }
        }
      }
    };
    this.basicOptions = {
      plugins: {
        legend: {
          labels: {
            color: '#495057'
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: '#495057'
          },
          grid: {
            color: '#ebedef'
          }
        },
        y: {
          ticks: {
            color: '#495057',
            beginAtZero: true,
            stepSize: 200
          },
          grid: {
            color: '#ebedef'
          }
        }
      }
    };
    // this.rankData = {
    //   labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    //   datasets: [
    //     {
    //       label: 'Rank',
    //       data: [0, 10, 5, 2, 20, 1, 12, 25, 20, 10, 8],
    //       fill: false,
    //       borderColor: '#42A5F5',
    //       tension: .4
    //     },
    //   ]
    // };
    // this.skillsData = {
    //   labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    //   datasets: [
    //     {
    //       label: 'Skills',
    //       data: [10, 1, 15, 23, 2, 12, 15, 5, 1, 10, 8],
    //       fill: false,
    //       borderColor: '#7CFC00',
    //       tension: .4
    //     },
    //   ]
    // };
    this.data = {
      // labels: ['Skill', 'Skill', 'Skill'],
      datasets: [
        {
          label: 'skill',
          data: [800, 210, 150, 225, 435, 100],
          borderRadius: 5,
          cutout: 60,
          cutoutPercentage: 40,
          backgroundColor: [
            'rgb(235, 124, 166)',
            'rgb(255, 172, 200)',
            'rgb(204, 111, 248)',
            'rgb(124, 92, 252)',
            'rgb(92, 175, 252)',
            'rgb(161, 169, 254)'
          ],
          hoverOffset: 10,
          spacing: 8
        }]
    };
    // this.data = {
    //   type: 'doughnut',
    //   weight: 2,
    //   // labels: ['Skill', 'Skill', 'Skill'],
    //   datasets: [
    //     {
    //       label: 'skill',
    //       data: [800, 210, 150, 225, 435, 100],
    //       borderRadius: 5,
    //       cutout: 60,
    //       cutoutPercentage: 40,
    //       weight: 5,
    //       backgroundColor: [
    //         'rgb(235, 124, 166)',
    //         'rgb(255, 172, 200)',
    //         'rgb(204, 111, 248)',
    //         'rgb(124, 92, 252)',
    //         'rgb(92, 175, 252)',
    //         'rgb(161, 169, 254)'
    //       ],
    //       hoverOffset: 10,
    //       spacing: 8,
    //     }]
    // }
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      this.userId = this.loggedInUser.userdata.id;
      this.isProfileCompleted = this.loggedInUser.userdata.isProfileComplete;
    }
    if (this.isLoggedIn == false) {
      this.router.navigate(['/']);
    }
    this.getUserDetails(this.userId);
    //this.getCareerDetails();
    //this.getOpponentsList();
    //this.getHighestSkillJumpData();
    //this.getTournamentsList();
    this.getSkill();
    this.getOpponents();
    this.getLastTournamentPlayed();
    this.getSkillChart();
    this.getPLayerTournamentParticipation();
    //this.getPlayerRanking(this.userId);
    //this.getPlayerSkills(this.userId);
    this.getPLayerHighestSkillJump()
    this.getPlayerSkillsForCategoryWise(this.userId)
    this.getPlayerRankingForcategoryWise(this.userId)
    this.userWallet(this.userId)
    this.getBankDetails(this.userId);
  }
   ngOnDestroy() {
    this.renderer.removeClass(document.body, 'profilePage');
  }
  onClickYear(event) {
    this.selectedYear = event.value;
    //this.getPlayerRanking(this.userId);
    this.getPlayerRankingForcategoryWise(this.userId)
    //this.getPlayerSkills(this.userId);
    this.getPlayerSkillsForCategoryWise(this.userId)
  }
  shareWhatsApp() {
    const heading = 'Hey there,';
    const subheading = "I've been using TPL App and it's been amazing! 👌 ";
    const titleparagraph = "If you're interested in trying it out, I have a referral code that can give you *1000 TPL Coins* when you sign up. ";
    const ReferralCode = "Here's my referral code:  *" + this.referralcode + "*\n";
    const referralCodeLink = "\nClick to Signup: " + frontEnd.domain + "/sign-up?ref=" + this.referralcode;
    const ReferralCodeinfo = "\nLet me know if you have any questions or need more info. ";

    const currentPageLink = window.location.href;
    const pagelink = '*' + currentPageLink + '*';

    // const org = 'For inquiries, contact ' + this.academyName + ' at ' + this.organizercontactnumber + '.';
    const text = 'Lets hit the court together and make this tournament an unforgettable experience! 🎾🏆';
    const seeyou = 'Cheers!';
    const phoneNumber = '1234567890'; // Replace with the recipient's phone number

    const siteIconUrl = frontEnd.domain + '/favicon.ico'; // Replace with your site's icon URL

    // Construct the WhatsApp sharing URL
    const message = encodeURIComponent(heading + '\n' + '\n' + subheading + '\n' + '\n' + titleparagraph + '\n' + '\n' + ReferralCode + referralCodeLink + '\n' + '\n' + ReferralCodeinfo + '\n' + '\n' + seeyou + '\n' + '\n' + '\n');
    console.log(message);
    const url = `https://api.whatsapp.com/send?text=${message}&link=${currentPageLink}&image=${siteIconUrl}`;

    window.open(url, '_blank');
  }

  getUserDetails(userId) {
    this.userService.getUserDetails(userId).subscribe(
      data => {
        this.item = data;
        if (this.item) {
          this.profileDetails = this.item;
          this.isProfileComplete = this.item['isProfileComplete'];
          if (this.isProfileComplete == false) {
            this.tooltipContent = "Please complete your profile to update KYC"
          }
          this.referralcode = this.item.referral_code;
          const heading = 'Hey there,';
          const subheading = "I've been using TPL App and it's been amazing! 👌 ";
          const titleparagraph = "If you're interested in trying it out, I have a referral code that can give you *1000 TPL Coins* when you sign up. ";
          const ReferralCode = "Here's my referral code: *" + this.referralcode + "*\n";
          const referralCodeLink = "\nClick to Signup: " + frontEnd.domain + "/login-register?ref=" + this.referralcode;
          const ReferralCodeinfo = "\nLet me know if you have any questions or need more info. ";

          const currentPageLink = window.location.href;
          const pagelink = '*' + currentPageLink + '*';

          // const org = 'For inquiries, contact ' + this.academyName + ' at ' + this.organizercontactnumber + '.';
          const text = 'Lets hit the court together and make this tournament an unforgettable experience! 🎾🏆';
          const seeyou = 'Cheers!';
          const phoneNumber = '1234567890'; // Replace with the recipient's phone number

          const siteIconUrl = 'https://www.tplsport.com/favicon.ico'; // Replace with your site's icon URL

          // Construct the WhatsApp sharing URL
          const message = encodeURIComponent(heading + '\n' + '\n' + subheading + '\n' + '\n' + titleparagraph + '\n' + '\n' + ReferralCode + referralCodeLink + '\n' + '\n' + ReferralCodeinfo + '\n' + '\n' + seeyou + '\n' + '\n' + '\n');

          this.shareurl = `https://api.whatsapp.com/send?text=${message}&link=${currentPageLink}&image=${siteIconUrl}`;
          var query = "?filterDisable=false&filterByuserId=" + userId;
          // this.userService.getUserKycDetailsList(query).subscribe(
          //   (data) => {
          //     data.items.forEach(kycElement=>{

          //       if(kycElement.isAadharVerified || kycElement.isPanVerified){
          //         console.log(kycElement)
          //         this.presentKycData = true;
          //        this.changeDetectorRef.detectChanges();

          //       }else if(!kycElement.isAadharVerified && !kycElement.isPanVerified){
          //         this.presentKycData = false;

          //       }
          //     })
          //     this.totalRecords = data.totalCount;
          //     // if (this.totalRecords < 1 ) {
          //     //   this.presentKycData = false
          //     // } else {
          //     //   this.presentKycData = true
          //     //   if(count==data.totalCount){
          //     //     this.presentButrejected=true
          //     //   }
          //     // }
          //   })
        }

      }, err => {
      });
  }
  getPlayerRanking(userId) {
    var query = "?filterDisable=false&filterByUserId=" + userId + "&filterByYear=" + this.selectedYear.year;
    this.userService.getUserRanking(query).subscribe(
      (data) => {
        let rankingData = data.data.items;
        let labelsArray = [];
        this.rankData = {};
        let dataSet = [];
        if (rankingData.length > 0) {
          rankingData.forEach(element => {
            labelsArray.push(moment(element.date).format('MMM YYYY'));
            dataSet.push(Number(element.playerRanking))
          });
          this.rankData = {
            labels: labelsArray,
            datasets: [
              {
                label: 'Rank',
                data: dataSet,
                fill: false,
                borderColor: '#42A5F5',
                tension: .4
              },
            ]
          };
        }

      })
  }
  getPlayerSkills(userId) {
    var query = "?filterDisable=false&filterByUserId=" + userId + "&filterByYear=" + this.selectedYear.year;
    this.userService.getUserSkills(query).subscribe(
      (data) => {
        let skillsData = data.data.items;
        let labelsArray = [];
        this.skillsData = {};
        let dataSet = [];
        if (skillsData.length > 0) {
          skillsData.forEach(element => {
            labelsArray.push(moment(element.date).format('MMM YYYY'));
            dataSet.push(Number(element.playerSkills))
          });
          this.skillsData = {
            labels: labelsArray,
            datasets: [
              {
                label: 'Skills',
                data: dataSet,
                fill: false,
                borderColor: '#eb7ca6',
                tension: .4
              },
            ]
          };
        }

      })
  }
  async getBankDetails(userId) {
    let query = "?filterByDisable=false&filterByStatus=true&filterByuserId=" + userId + "&filterByPrimary=true";
    this.userService.getUserKycDetailsList(query).subscribe(
      res => {
        if (res.items.length > 0) {
          this.kycDetails = res.items[0]
          this.kycVerificationComplete = this.kycDetails?.isDocumentComplete
          if (this.kycDetails.isAadharVerified || this.kycDetails.isPanVerified) {
            this.presentKycData = true;
            this.changeDetectorRef.detectChanges();

          } else if (!this.kycDetails.isAadharVerified && !this.kycDetails.isPanVerified) {
            this.presentKycData = false;

          }
        }
      },
      err => {
      }
    );
  }
  loadUserKyc(event: LazyLoadEvent) {
    var query = "?filterDisable=false&filterByuserId=" + this.userId;
    this.userService.getUserKycDetailsList(query).subscribe(
      (data) => {
        this.loading = false;
        this.kycData = data.items;
        //         this.kycData.forEach(ele => {
        //   if (ele.panCardNumber != null) {
        //     ele.panCardNumber = CryptoJS.AES.decrypt(ele.panCardNumber, this.key, {
        //       keySize: 128 / 8,
        //       iv: this.iv, mode: CryptoJS.mode.CBC,
        //       padding: CryptoJS.pad.Pkcs7
        //     }).toString(CryptoJS.enc.Utf8)
        //   }
        //   if (ele.gstNumber != null) {
        //     ele.gstNumber = CryptoJS.AES.decrypt(ele.gstNumber, this.key, {
        //       keySize: 128 / 8,
        //       iv: this.iv, mode: CryptoJS.mode.CBC,
        //       padding: CryptoJS.pad.Pkcs7
        //     }).toString(CryptoJS.enc.Utf8)
        //   }
        //   if (ele.adharCardNumber != null) {
        //     ele.adharCardNumber = CryptoJS.AES.decrypt(ele.adharCardNumber, this.key, {
        //       keySize: 128 / 8,
        //       iv: this.iv, mode: CryptoJS.mode.CBC,
        //       padding: CryptoJS.pad.Pkcs7
        //     }).toString(CryptoJS.enc.Utf8)
        //   }
        //   ele.bankName = CryptoJS.AES.decrypt(ele.bankName, this.key, {
        //     keySize: 128 / 8,
        //     iv: this.iv, mode: CryptoJS.mode.CBC,
        //     padding: CryptoJS.pad.Pkcs7
        //   }).toString(CryptoJS.enc.Utf8)
        //   ele.accountNumber = CryptoJS.AES.decrypt(ele.accountNumber, this.key, {
        //     keySize: 128 / 8,
        //     iv: this.iv, mode: CryptoJS.mode.CBC,
        //     padding: CryptoJS.pad.Pkcs7
        //   }).toString(CryptoJS.enc.Utf8)
        //   ele.ifsc = CryptoJS.AES.decrypt(ele.ifsc, this.key, {
        //     keySize: 128 / 8,
        //     iv: this.iv, mode: CryptoJS.mode.CBC,
        //     padding: CryptoJS.pad.Pkcs7
        //   }).toString(CryptoJS.enc.Utf8)
        // })
        this.totalRecords = data.totalCount;
      }
    );
  }
  getSkill() {
    this.commonService.getSkillInfoList().subscribe(
      data => {
        this.skillinfoDetails = data;
        this.winloss = data?.winlossData
        this.careerDetails = this.selectedYear.year
      }, err => {
      });
  }
  getOpponents() {
    this.commonService.getSkillOpponents().subscribe(
      data => {
        this.opponentList = data.items
      },
    );
  }
  getSkillChart() {
    this.careerService.getTournamentScoreSkills().subscribe(
      (result: any) => {
        this.playerRating = result?.data?.highestskilljump?.playerRating;
        const TotalRating = result?.data?.skill?.map((res: any) => {
          return res?.TotalRating
        })
        // this.data = {
        //   type: 'doughnut',
        //   weight: 2,
        //   datasets: [
        //     {
        //       label: 'skill',
        //       data: TotalRating,
        //       borderRadius: 5,
        //       cutout: 60,
        //       cutoutPercentage: 40,
        //       weight: 5,
        //       backgroundColor: [
        //         'rgb(235, 124, 166)',
        //         'rgb(255, 172, 200)',
        //         'rgb(204, 111, 248)',
        //         'rgb(124, 92, 252)',
        //         'rgb(92, 175, 252)',
        //         'rgb(161, 169, 254)'
        //       ],
        //       hoverOffset: 10,
        //       spacing: 8,
        //     }]
        // }
      },
    );
  }
  getLastTournamentPlayed() {
    this.commonService.getLastTournamentPlayed().subscribe(
      data => {
        this.tournamentList = data.items
      }, err => {
      });
  }

  getPLayerTournamentParticipation() {
    this.profileService.getTournamentParticipation().subscribe(
      data => {
        this.tournamentParticapation = data
      }, err => {
      });
  }

  getPLayerHighestSkillJump() {
    this.profileService.getHighestSkillJump().subscribe(
      data => {
        this.highestSkillJump = data.items?.listHighestSkillJump[0];
        this.playerRatingForHighestSkillJump = data.items.listHighestSkillJump[0]?.myRating.winnerRating == undefined ? data.items.listHighestSkillJump[0]?.myRating.looserRating : data.items.listHighestSkillJump[0]?.myRating.winnerRating;
        this.opponentRating = data.items.listHighestSkillJump[0]?.opponentRating.winnerRating == undefined ? data.items.listHighestSkillJump[0]?.opponentRating.looserRating : data.items.listHighestSkillJump[0]?.opponentRating.winnerRating;
        this.oldplayerLastRating = data.items.listHighestSkillJump[0]?.myRating.winnerRating == undefined ? data.items.listHighestSkillJump[0]?.looseroldLastRating : data.items.listHighestSkillJump[0]?.winneroldLastRating;
        this.lessplayerRating = this.playerRatingForHighestSkillJump - this.oldplayerLastRating;
        this.plusminus = this.playerRatingForHighestSkillJump > this.oldplayerLastRating ? '+' : '';

      }, err => {
      });
  }

  getPlayerSkillsForCategoryWise(userId) {
    var query = "?filterDisable=false&filterByUserId=" + userId + "&filterByYear=" + this.selectedYear.year;
    this.userService.getUserSkillsForCategoryWise(query).subscribe(
      (data) => {
        let skillsData = data.data.items;
        let labelsArray = [];
        let labelsArrayCategory = [];
        this.skillsData = {};
        let dataSet = [];

        if (skillsData.length > 0) {
          skillsData.forEach(element => {
            labelsArray.push(moment(element.date).format('MMM YYYY'));
            labelsArrayCategory.push(element.matchname[0] + element.agegroupname[0]);
            let obj = {
              label: element.matchname[0] + " " + element.agegroupname[0],
              data: element.playerRating,
              fill: false,
              borderColor: '#eb7ca6',
              tension: .4
            }
            dataSet.push(obj);
          })
          this.skillsData = {

            labels: labelsArray,
            datasets: dataSet

          };
        }

      })

  }


  getPlayerRankingForcategoryWise(userId) {
    var query = "?filterDisable=false&filterByUserId=" + userId + "&filterByYear=" + this.selectedYear.year;
    this.userService.getUserRankingForCategoryWise(query).subscribe(
      (data) => {

        let rankData = data.data.items;
        let labelsArray = [];
        let labelsArrayCategory = [];
        let dataSet = [];

        if (rankData.length > 0) {
          rankData.forEach(element => {
            labelsArray.push(moment(element.date).format('MMM YYYY'));
            labelsArrayCategory.push(element.matchname[0] + element.agegroupname[0]);
            let obj = {
              label: element.matchname[0] + " " + element.agegroupname[0],
              data: element.pointsEarn,
              fill: false,
              borderColor: '#eb7ca6',
              tension: .4
            }
            dataSet.push(obj);
          })
          this.rankData = {

            labels: labelsArray,
            datasets: dataSet

          };
        }

      }

    )
  }
  viewRejectReasonModal(data) {
    this.rejectKycReasonView = true
    this.viewReason = data.rejectedReason
  }
  userWallet(userId) {
    var query = "?filterByDisable=false&filterByUserid=" + userId;

    // filterByUserid
    this.walletService.getUserWalletList(query).subscribe(
      data => {
        console.log(data.data.totalDeductedCash)
        this.loading = false;
        this.cashSpend = data.data.totalDeductedCash;
        if (this.cashSpend >= 25000) {
          this.userBadge = "Gold";
        } else if (this.cashSpend >= 15000 && this.cashSpend < 25000) {
          this.userBadge = "Silver";
          this.badgeAmout = 25000;
          this.cashSpendPercent = this.cashSpend / this.badgeAmout * 100
          this.amountToSpend = this.badgeAmout - this.cashSpend
        } else if (this.cashSpend < 15000) {
          this.userBadge = "Bronze";
          this.badgeAmout = 15000;
          this.cashSpendPercent = this.cashSpend / this.badgeAmout * 100
          this.amountToSpend = this.badgeAmout - this.cashSpend

        }
      },
      err => {
      });
  }
  onDownloadClick(position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright'){
  this.position = position;
  this.downloadModal = true; 
}
 signOut() {
    const localStorageFullAndroidCondition = localStorage.getItem('fullAndroid');
    const fullAndroid = localStorageFullAndroidCondition && JSON.parse(localStorageFullAndroidCondition);
    window.sessionStorage.clear();
    this.tokenStorage.isLoggedOut();
    let currentUrl = '/';
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    if (fullAndroid) {
      this.router.navigate([currentUrl], { queryParams: { fullAndroid: true } });
    } else {
      this.router.navigate([currentUrl]);
    }
    return false;
  }
}


